// extracted by mini-css-extract-plugin
export default {"footer":"B-z","footerContainer":"C-z"};